import type { Router } from 'vue-router'

import axios from 'axios'
import { configureDynamicParamsMenu } from '../helper/menuHelper'
import type { Menu } from '../types'
import { PermissionModeEnum } from '@/enums/appEnum'
import { useAppStoreWithOut } from '@/store/modules/app'
import { usePermissionStoreWithOut } from '@/store/modules/permission'

export function createParamMenuGuard(router: Router) {
  const permissionStore = usePermissionStoreWithOut()
  router.beforeEach(async (to, _, next) => {
    // console.log('to', to)
    if (to.path.includes('largeScreen')) {
      // 并且将所有的概览目录下设置隐藏
      to.meta.hiddenFooter = true
      // console.log('menuFilter✨✨✨✨✨', to)
    }

    await versionCheck()
    if (!to.name) {
      next()
      return
    }

    // menu has been built.
    if (!permissionStore.getIsDynamicAddedRoute) {
      next()
      return
    }

    let menus: Menu[] = []
    if (isBackMode())
      menus = permissionStore.getBackMenuList
    else if (isRouteMappingMode())
      menus = permissionStore.getFrontMenuList

    menus.forEach(item => configureDynamicParamsMenu(item, to.params))

    next()
  })
}

function getPermissionMode() {
  const appStore = useAppStoreWithOut()
  return appStore.getProjectConfig.permissionMode
}

function isBackMode() {
  return getPermissionMode() === PermissionModeEnum.BACK
}

function isRouteMappingMode() {
  return getPermissionMode() === PermissionModeEnum.ROUTE_MAPPING
}

// 版本监控
async function versionCheck() {
  // showAlert('新版本发布，自动更新中...')
  if (import.meta.env.MODE === 'development')
    return
  // console.log(' 版本监控 __APP_INFO__', version, __APP_INFO__.lastBuildTimeStamp)
  try {
    const version = localStorage.getItem('version')
    console.log(' 版本监控 version', version)
    const response = await axios.get(`/version.json?time=${new Date().getTime()}`)
    if (version) {
      if (version !== JSON.stringify(response.data.version) && import.meta.env.VITE_CHECK_VERSION_ENABLE) {
        localStorage.setItem('version', JSON.stringify(response.data.version))

        // alert('新版本发布，自动更新中...')
        // 使用函数显示一个消息提示
        showAlert('新版本发布，自动更新中...')
        window.location.reload()
      }
    }
    else {
      localStorage.setItem('version', JSON.stringify(response.data.version))
    }
    // console.log('版本监控 response', response)
  }
  catch (e) {
    console.log('版本监控', e)
  }
}

// 创建一个消息提示函数
function showAlert(message) {
  // 创建一个新的div元素作为消息提示
  const alertBox = document.createElement('div') as any
  alertBox.classList.add('alert-box') // 添加样式类
  alertBox.textContent = message // 设置消息内容

  // 将消息提示添加到body中
  document.body.appendChild(alertBox)
  // 设置一个定时器在1.5秒后移除消息提示
  setTimeout(() => {
    // 从DOM中移除消息提示
    alertBox?.parentNode.removeChild(alertBox)
  }, 1500)
}
